(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-marquee"] && !Shopify.designMode) return;
  try {
    
  /** code by squarestylist.com — standoutshopify.com **/
  (function () {
    if (customElements.get('sqsh-testimonial-marquee')) return;

    const MOBILE_BREAKPOINT = 749;
    const EASE = (t) => t * t * (3 - 2 * t);

    class SqshTestimonialMarquee extends HTMLElement {
      connectedCallback() {
        this._track = this.querySelector('[data-track]');
        this._slider = this.querySelector('[data-slider]');
        this._items = this.querySelector('[data-items]');
        this._prevBtn = this.querySelector('[data-prev]');
        this._nextBtn = this.querySelector('[data-next]');
        this._originalCards = this._items
          ? [...this._items.children]
          : [];
        this._totalSlides = this._originalCards.length;
        this._currentSlide = 0;
        this._clones = [];
        this._duplicateItems = null;
        this._boundHandlers = {};

        this._mq = window.matchMedia(
          `(max-width: ${MOBILE_BREAKPOINT}px)`
        );
        this._onMqChange = () => {
          this._teardown();
          requestAnimationFrame(() => this._init());
        };
        this._mq.addEventListener('change', this._onMqChange);

        requestAnimationFrame(() => this._init());
      }

      disconnectedCallback() {
        this._mq.removeEventListener('change', this._onMqChange);
        this._teardown();
      }

      /* ── Mode switching ── */

      _init() {
        if (this._totalSlides === 0) return;
        if (this._mq.matches) {
          this._initCarousel();
        } else {
          this._initMarquee();
        }
      }

      _teardown() {
        /* Remove marquee clones */
        this._clones.forEach((c) => c.remove());
        this._clones = [];
        if (this._duplicateItems) {
          this._duplicateItems.remove();
          this._duplicateItems = null;
        }
        /* Remove carousel listeners */
        if (this._boundHandlers.prev)
          this._prevBtn?.removeEventListener(
            'click',
            this._boundHandlers.prev
          );
        if (this._boundHandlers.next)
          this._nextBtn?.removeEventListener(
            'click',
            this._boundHandlers.next
          );
        if (this._boundHandlers.scroll)
          this._track?.removeEventListener(
            'scroll',
            this._boundHandlers.scroll
          );
        /* Remove hover-pause listeners */
        if (this._boundHandlers.enter)
          this._slider?.removeEventListener(
            'pointerenter',
            this._boundHandlers.enter
          );
        if (this._boundHandlers.leave)
          this._slider?.removeEventListener(
            'pointerleave',
            this._boundHandlers.leave
          );
        this._boundHandlers = {};

        /* Reset scroll position */
        if (this._track) this._track.scrollLeft = 0;
        this._currentSlide = 0;
      }

      /* ── Desktop: Marquee ── */

      _initMarquee() {
        if (!this._items) return;

        const itemsWidth = this._items.scrollWidth;
        const viewportWidth = this.clientWidth;
        if (itemsWidth === 0) return;

        const copies =
          Math.ceil(viewportWidth / itemsWidth) + 1;

        /* Clone cards within __items to fill the viewport */
        for (let i = 0; i < copies - 1; i++) {
          this._originalCards.forEach((card) => {
            const clone = card.cloneNode(true);
            clone.removeAttribute('id');
            this._items.appendChild(clone);
            this._clones.push(clone);
          });
        }

        /* Duplicate entire __items for seamless loop */
        this._duplicateItems = this._items.cloneNode(true);
        this._duplicateItems.setAttribute('aria-hidden', 'true');
        this._duplicateItems.removeAttribute('data-items');
        this._slider.appendChild(this._duplicateItems);

        /* Set animation speed */
        const speedFactor = parseInt(
          this.dataset.speedFactor || '50',
          10
        );
        const speed = Math.sqrt(copies) * speedFactor;
        this.style.setProperty('--sqsh-tm-speed', `${speed}s`);

        /* Hover pause */
        if (this.hasAttribute('data-hover-pause')) {
          this._initHoverPause();
        }
      }

      /* ── Mobile: Carousel ── */

      _initCarousel() {
        this._currentSlide = 0;
        this._updateButtons();

        this._boundHandlers.prev = () => this._navigate(-1);
        this._boundHandlers.next = () => this._navigate(1);
        this._prevBtn?.addEventListener(
          'click',
          this._boundHandlers.prev
        );
        this._nextBtn?.addEventListener(
          'click',
          this._boundHandlers.next
        );

        /* Update buttons when user swipes */
        let scrollTimer;
        this._boundHandlers.scroll = () => {
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(() => {
            const w = this._track?.clientWidth;
            if (w && w > 0) {
              this._currentSlide = Math.round(
                this._track.scrollLeft / w
              );
              this._updateButtons();
            }
          }, 100);
        };
        this._track?.addEventListener(
          'scroll',
          this._boundHandlers.scroll,
          { passive: true }
        );
      }

      _navigate(dir) {
        const next = this._currentSlide + dir;
        if (next < 0 || next >= this._totalSlides) return;
        this._currentSlide = next;

        const card = this._items?.children[this._currentSlide];
        if (card) {
          card.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start',
          });
        }
        this._updateButtons();
      }

      _updateButtons() {
        if (this._prevBtn)
          this._prevBtn.disabled = this._currentSlide <= 0;
        if (this._nextBtn)
          this._nextBtn.disabled =
            this._currentSlide >= this._totalSlides - 1;
      }

      /* ── Hover pause ── */

      _initHoverPause() {
        let activeAnim = null;
        let slowTimer;

        const getAnim = () =>
          this._slider?.getAnimations()[0] ?? null;

        const animateRate = (from, to, onDone) => {
          const start = performance.now();
          let cancelled = false;
          let current = from;

          const tick = (now) => {
            if (cancelled) return;
            const p = Math.min((now - start) / 500, 1);
            current = from + (to - from) * EASE(p);
            const a = getAnim();
            if (a) a.updatePlaybackRate(current);
            if (p < 1) requestAnimationFrame(tick);
            else onDone?.();
          };
          requestAnimationFrame(tick);

          return {
            get current() {
              return current;
            },
            cancel() {
              cancelled = true;
            },
          };
        };

        this._boundHandlers.enter = () => {
          clearTimeout(slowTimer);
          slowTimer = setTimeout(() => {
            if (activeAnim) return;
            activeAnim = animateRate(1, 0, () => {
              activeAnim = null;
            });
          }, 500);
        };

        this._boundHandlers.leave = () => {
          clearTimeout(slowTimer);
          const a = getAnim();
          if (!a || a.playbackRate === 1) return;
          const from = activeAnim?.current ?? 0;
          activeAnim?.cancel();
          activeAnim = animateRate(from, 1, () => {
            activeAnim = null;
          });
        };

        this._slider?.addEventListener(
          'pointerenter',
          this._boundHandlers.enter
        );
        this._slider?.addEventListener(
          'pointerleave',
          this._boundHandlers.leave
        );
      }
    }

    customElements.define(
      'sqsh-testimonial-marquee',
      SqshTestimonialMarquee
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
